<re-captcha (resolved)="_resolved($event)" [siteKey]=getSiteKey()>
</re-captcha>